import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class IconsService {

  private http = inject(HttpClient)
  private url = '/assets/config.json'
  private iconsSanitize = []

  constructor() { }

  public setIcon(): any {
    this.http.get(this.url)
      .subscribe({
        next: (icon: any) => {
          for (let i of icon.glyphs) {
            this.iconsSanitize[i.css] = i.svg
          }
        }
      })
  }

  public getIcon(svg: string): Observable<any> {
    return this.iconsSanitize[svg]
  }




}
